module.exports = __webpack_public_path__ + "static/img/brand-fourth-right.902a598a.png";